import { Fragment } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Col } from '@crehana/ui';
import { grayLighter } from '@crehana/ui/dist/styles/colors';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

import useCheckoutCtx from '@/views/B2BCheckout/hooks/useCheckoutCtx';

import CardLogos from './components/CardLogos';
import Features from './components/Features';
import Guarantee from './components/Guarantee';
// import LicenceCounter from './components/LicenceCounter';
import PurchaseSummary from './components/PurchaseSummary';

const UIRight = styled(Col)`
  position: relative;
  min-height: calc(100vh - 72px);
  &:before,
  &:after {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    background-color: ${grayLighter};
    height: 100%;
    width: calc(100%);
  }
  &:before {
    content: '';
    ${({ theme }) => theme.breakpoints.up('md')} {
      content: unset;
    }
    transform: translateX(-100%);
  }
  &:after {
    content: '';
    transform: translateX(100%);
  }
`;

const RightUI = () => {
  const {
    state: { currentStep },
  } = useCheckoutCtx();

  return (
    <UIRight
      md={5}
      offset={{ md: 1 }}
      nowrap
      className="bg-gray-lighter sm:py-32 py-48 md:pl-56 lg:pl-104"
    >
      <PurchaseSummary />
      {currentStep === 3 ? (
        <Fragment>
          <CardLogos />
          <Guarantee />
        </Fragment>
      ) : (
        <Features />
      )}
    </UIRight>
  );
};

export default RightUI;
